export class ValidationError extends Error {
    constructor(name, message) {
        super(`Invalid "${name}" provided, ` + message);
        this.name = 'ValidationError';
    }
}
